import React, { useState } from 'react'
import { View } from 'react-native'
import ThemedBlock from 'components/atoms/ThemedBlock'
import ThemedSelect from 'components/atoms/ThemedSelect'
import ThemedInputSearch from 'components/atoms/ThemedInputSearch'
import { transportList } from 'utils/constants/transport-constants'
import _ from 'lodash'
import ObjectTransport from 'utils/objects/transport'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { travelHistoryViewStyles } from 'styles/components/atoms/TravelHistoryView'


const TravelHistoryView = () => {

	const [transportType, setTransportType] = useState( null )
	
	const onSearch = ( value ) => {
	}
	
	// Find the correct icon
	const transportIcon = ObjectTransport.getIcon( transportType, {
		size: 20
	})
	
	return (
		<ThemedBlock shadow smallPadding>
			{/* Row */}
			<View style={ [ travelHistoryViewStyles.row, travelHistoryViewStyles.rowSpacing ] }>
				<View style={ travelHistoryViewStyles.columnIcon }>
					<Icon icon={ IconSystemConstants.CIRCLE_OUTLINE } size={ 10 } />
					
					<Icon icon={ IconSystemConstants.DOTS_VERTICAL } size={ 16 } style={ travelHistoryViewStyles.icon } />
				</View>
				
				<View style={ travelHistoryViewStyles.columnInput }>
					<ThemedInputSearch
						onChangeText={ _.debounce( onSearch, 500 ) }
					/>
				</View>
			</View>
			
			{/* Row */}
			<View
				style={ travelHistoryViewStyles.row }>
				
				<View style={ travelHistoryViewStyles.columnIcon }>
					{ transportIcon }
				</View>
				
				<View
					style={ travelHistoryViewStyles.columnInput }>
					
					<ThemedSelect
						select={ setTransportType.bind( this ) }
						selected={ transportType }
						options={ _.map( transportList, o => {
							return (
								{
									value: o,
									label: o
								}
							);
						})}
					/>
				</View>
			</View>
		</ThemedBlock>
	)
}

export default TravelHistoryView
